import { watch, ref } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { usePersonalizedStore } from '@/store/modules/personalized'
import { useI18n } from '@/hooks/web/useI18n'

export const useTitle = (newTitle?: string) => {
  const { t } = useI18n()
  const appStore = useAppStoreWithOut()
  const personalizedStore = usePersonalizedStore()

  const baseTitle = () => personalizedStore.config.systemName || appStore.getTitle

  const title = ref(newTitle ? `${baseTitle()} - ${t(newTitle as string)}` : baseTitle())

  watch(
    title,
    (n, o) => {
      if (isString(n) && n !== o && document) {
        document.title = n
      }
    },
    { immediate: true }
  )

  // 个性化配置后加载回来时，用系统名称刷新标题
  watch(
    () => personalizedStore.config.systemName,
    (n) => {
      if (n && document) {
        document.title = newTitle ? `${n} - ${t(newTitle as string)}` : n
      }
    }
  )

  return title
}
